export type CustomerStepField = {
  name: string;
  title: string;
  placeholder?: string;
  required?: boolean;
  type?: string;
  fields?: CustomerStepField[];
};

export const step1Fields: CustomerStepField[] = [
  {
    name: "outletName",
    title: "Outlet Name",
    placeholder: "",
    required: true,
  },
  {
    name: "companyGST",
    title: "Company GST Number",
    placeholder: "",
    required: true,
  },
  {
    name: "companyPAN",
    title: "Company PAN Number",
    placeholder: "",
    required: true,
  },
  {
    name: "pincode",
    title: "Pincode",
    placeholder: "",
    required: true,
  },
  {
    name: "emailID",
    title: "Email ID",
    placeholder: "",
    required: true,
  },
  {
    name: "gstStateCode",
    title: "GST State Code",
    placeholder: "",
    required: false,
  },
  {
    name: "authorizedSignatory",
    title: "Company Authorized Signatory (Name)",
    placeholder: "",
    required: false,
  },
  {
    name: "vatNumber",
    title: "VAT Number (if applicable)",
    placeholder: "",
    required: false,
  },
  {
    name: "phoneNumber",
    title: "Phone Number",
    placeholder: "",
  },
  {
    name: "registeredAddress",
    title: "Registered Address (as per GST)",
    placeholder: "",
    required: true,
    type: "textarea",
  },
  {
    title: "Company GST Certificate",
    name: "comp_gst_cert",
    required: true,
    type: "file",
  },
  {
    title: "Company PAN Card",
    name: "comp_pan_card",
    required: true,
    type: "file",
  },
  {
    title: "VAT Certificate (if applicable)",
    name: "comp_vat_cert",
    type: "file",
  },
];

export const step2Fields: CustomerStepField[] = [
  {
    name: "licenseName",
    title: "License Name",
    placeholder: "",
    required: true,
  },
  {
    name: "customerExciseRegistrationNumber",
    title: "Customer Excise Registration Number",
    placeholder: "",
    required: true,
  },
  {
    name: "licensePAN",
    title: "License PAN Number",
    placeholder: "",
    required: true,
  },
  {
    name: "licenseGST",
    title: "License GST Number",
    placeholder: "",
  },
  {
    name: "ksbclCode",
    title: "KSBCL Code",
    placeholder: "",
    required: true,
  },
  {
    name: "gstStateCode",
    title: "GST State Code",
    placeholder: "",
    required: true,
  },
  {
    name: "licenseAddress",
    title: "Registered Address (as per License)",
    placeholder: "",
    required: true,
    type: "textarea",
  },
  {
    title: "RVB License Copy (Signed and Sealed by Excise Range Officer)",
    name: "lic_rvb_license",
    required: true,
    type: "file",
  },
  {
    title: "License PAN Card",
    name: "lic_license_pan",
    required: true,
    type: "file",
  },
  {
    title: "License GST Certificate",
    name: "lic_gst_cert",
    type: "file",
  },
];

export const step3Fields: CustomerStepField[] = [
  {
    name: "bankName",
    title: "Bank Name",
    placeholder: "",
    required: true,
  },
  {
    name: "bankBranch",
    title: "Bank Branch",
    placeholder: "",
    required: true,
  },
  {
    name: "accountType",
    title: "Account Type",
    placeholder: "",
    required: false,
  },
  {
    name: "accountNumber",
    title: "Account Number",
    placeholder: "",
    required: true,
  },
  {
    name: "ifscCode",
    title: "IFSC Code",
    placeholder: "",
    required: true,
  },
  {
    name: "beneficiaryName",
    title: "Beneficiary Name",
    placeholder: "",
    required: true,
  },
  {
    name: "accountsDepartmentPOCName",
    title: "Accounts Department POC: Name",
    placeholder: "",
    required: false,
  },
  {
    name: "accountsDepartmentPOCNumber",
    title: "Accounts Department POC: Number",
    placeholder: "",
    required: false,
  },
  {
    title: "Cancelled Cheque Copy",
    name: "bank_cancelled_cheque",
    required: true,
    type: "file",
  },
];
